export default function GetColor(str) {
    if (typeof str !== 'string') throw new Error("Not a string");

    var hash = 0;
    if (str.length === 0) return hash;

    for (var i = 0; i < str.length; i++) {
        hash = str.charCodeAt(i) + ((hash << 5) - hash);
    }

    var color = "#";
    for (var i = 0; i < str.length; i++) {
        var value = (hash >> (i * 8) & 255);
        color += ('00' + value.toString(16)).substr(-2);
    }

    return color.substr(0, 7);
}


// WEBPACK FOOTER //
// ./src/js/GetColor.js